import { useState, useEffect, useCallback } from 'react'
import { prospectsApi } from '../api/prospects'

export function useProspects() {
  const [prospects, setProspects] = useState([])
  const [total, setTotal] = useState(0)
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(null)

  const [filters, setFilters] = useState({
    search: '',
    status: '',
    industry: '',
    source: '',
    category: '',
    page: 1,
    page_size: 12,
    sort_by: 'created_at',
    sort_dir: 'desc',
  })

  const fetch = useCallback(async () => {
    setLoading(true)
    setError(null)
    try {
      const params = Object.fromEntries(
        Object.entries(filters).filter(([, v]) => v !== '')
      )
      const res = await prospectsApi.list(params)
      setProspects(res.data.results)
      setTotal(res.data.total)
    } catch (e) {
      setError(e.response?.data?.detail || 'Failed to load prospects')
    } finally {
      setLoading(false)
    }
  }, [filters])

  useEffect(() => { fetch() }, [fetch])

  const updateFilter = (key, value) =>
    setFilters((f) => ({ ...f, [key]: value, page: key === 'page' ? value : 1 }))

  const create = async (data) => {
    await prospectsApi.create(data)
    fetch()
  }

  const update = async (id, data) => {
    await prospectsApi.update(id, data)
    fetch()
  }

  const remove = async (id) => {
    await prospectsApi.delete(id)
    fetch()
  }

  const exportCSV = () =>
    prospectsApi.exportCSV(
      Object.fromEntries(
        Object.entries(filters).filter(([k, v]) => ['search','status','industry','source','category'].includes(k) && v !== '')
      )
    )

  return { prospects, total, loading, error, filters, updateFilter, create, update, remove, exportCSV, refresh: fetch }
}